import styled from "styled-components";
import { colors } from "../../consts";
import { device } from "../../services";
import { Paragraph2, FlexContainers, WrapperContainer } from "../../components";

export const NotificationWrapper = styled(WrapperContainer)`
  border-radius: 8px;

  background: ${colors.ISABELLINE};
`;

export const NotificationContainer = styled(FlexContainers.FlexRowStart)`
  width: 445px;
  border-radius: 8px;
  padding: 26px;
  background: ${(props) =>
    props?.type === "success" ? "rgba(43, 186, 153, 0.1)" : "rgba(199, 54, 54, 0.1)"};
  border: 1px solid;
  border-color: ${(props) => (props?.type === "success" ? colors.SUCCESS : colors.ERROR)};
  align-items: flex-start;

  @media screen and ${device.laptop} {
    max-width: 400px;
  }

  @media screen and ${device.tablet} {
    max-width: 360px;
  }
`;

export const NotificationContentWrapper = styled(FlexContainers.FlexRowStart)`
  width: 100%;
  align-items: center;
  gap: 8px;

  a {
    text-decoration: underline;
    text-decoration-color: ${colors.RAISIN_100};
    font-weight: 700;
  }

  a:visited {
    color: ${colors.RAISIN_100};
  }

  @media screen and ${device.tablet} {
    flex-direction: column;
  }
`;

export const InfoContianer = styled(FlexContainers.FlexColumnStart)`
  margin-left: 22px;
  align-items: flex-start;

  ${Paragraph2} {
    color: ${colors.RAISIN_100};
    word-break: break-word;
  }
`;

export const Title = styled(Paragraph2)`
  font-weight: 700;
  margin-bottom: 4px;
  word-break: break-word;
`;
